import type {
  AgentDeliver,
  AgentFeed,
  AgentSubjectType,
  AgentThread,
  AgentThreadKind,
  CreateAgentUpload200
} from '@api/models';

import { BrowserApiClient } from '@website/lib/api/browser';

/** The admin agents (assistant chats, review threads): thin wrappers over the generated admin-gated client. */

export const listAgentThreads = async (
  kind: `${AgentThreadKind}`,
  subject?: { type: `${AgentSubjectType}`; id: string }
): Promise<{ threads: AgentThread[]; available: boolean }> =>
  BrowserApiClient.listAgentThreads({
    kind: kind as AgentThreadKind,
    ...(subject ? { subjectType: subject.type as AgentSubjectType, subjectId: subject.id } : {})
  });

export const startAgentThread = async (title?: string): Promise<AgentThread> =>
  BrowserApiClient.startAgentThread(title ? { title } : {});

export const deleteAgentThread = async (id: string) => BrowserApiClient.deleteAgentThread(id);

export const getAgentThread = async (id: string): Promise<AgentThread> => BrowserApiClient.getAgentThread(id);

export const requestAgentReview = async (subjectType: `${AgentSubjectType}`, subjectId: string): Promise<AgentThread> =>
  BrowserApiClient.requestAgentReview({ subjectType: subjectType as AgentSubjectType, subjectId });

export const getAgentFeed = async (id: string, after: string | null): Promise<AgentFeed> =>
  BrowserApiClient.getAgentFeed(id, after ? { after } : undefined);

export const sendAgentMessage = async (id: string, text: string, deliver: `${AgentDeliver}`, files?: string[]) =>
  BrowserApiClient.sendAgentMessage(id, {
    text,
    deliver: deliver as AgentDeliver,
    ...(files?.length ? { files } : {})
  });

export const interruptAgentThread = async (id: string) => BrowserApiClient.interruptAgentThread(id, {});

export const cancelAgentMessage = async (id: string, messageId: string) =>
  (await BrowserApiClient.cancelAgentMessage(id, messageId)).result;

export const createAgentUpload = async (
  id: string,
  file: { name: string; mediaType: string; size: number }
): Promise<CreateAgentUpload200> => BrowserApiClient.createAgentUpload(id, file);
